module.exports = __webpack_public_path__ + "res/24-img_reward_m.8c11b19cf4d0d6dcb0f3177273e7f8f2.png";